// extracted by mini-css-extract-plugin
module.exports = {"topic":"Topic_topic__vyZtl","collapseWrapper":"Topic_collapseWrapper__pzGWN"};